module.exports = __webpack_public_path__ + "static/media/ic_wcag_text_large.4e7893e9.svg";